export enum PolygonSelectorServiceType {
  Default = 'default',
  Potential_Zones = 'highPotentialZones'
}